export const rudderDataPlaneUrl = 'https://restorehyphrdv.dataplane.rudderstack.com';
export const STORAGE_KEY_TRAITS = 'rl_trait';
